export default(function(value){return typeof Map!=='undefined'&&value instanceof Map;});